<template>
  <main-layout>
    <h1 class="title">Crea tipologia corso</h1>
    <course-type-form
      :submit-action="create"
      :fields="fields"
      redirect-route="courseTypes.show"
    />
  </main-layout>
</template>

<script>
import { call } from "vuex-pathify"

import CourseTypeForm from "@/components/CourseTypeForm.vue"
import MainLayout from "@/layouts/Main.vue"

export default {
  components: {
    CourseTypeForm,
    MainLayout
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    create: call("courseTypes/create")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
